import React, { Component } from 'react'
import VariationRepository from '../../Merchant/Repository/VariationRepository'

export default class SelectedVariationListing extends Component {

    constructor(props) {
        super(props)
        this.state = {
            variations: [],
        }

        this.callbackKey =  "SelectedVariationListing_"+this.props.order.id
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.order !== this.props.order) {
            this.loadVariationIfNeeded(this.props.order)
        }
    }
    componentDidMount() {
        let { order }= this.props;
        if (!order) {
            return
        }
        this.loadVariationIfNeeded(this.props.order)
    }
    componentWillUnmount() {
        VariationRepository.getInstance().removeCallback(null, this)
    }
    loadVariationIfNeeded = (order) => {
        (order.variation_ids || []).forEach(variationId => {
            let found = this.props.app.state.variations.find((item) => item.id == variationId)
            if (!found) {
                VariationRepository.getInstance().loadOneByApi(variationId, (variation) => {
                    let variations = this.state.variations
                    let index = variations.findIndex(v => v.id == variation[0].id)
                    if (index === -1) {
                        variations.push(variation[0])
                    }
                    else {
                        variations.splice(index, 1, variation[0])
                    }
                    this.setState({ variations })
                }, this.callbackKey, this)
            }
        })
    }
    getVariation = (variationId) => {
        // Default get from app main Firebase source
        let variation = this.props.app.state.variations.find((item) => item.id == variationId)
        if (!variation) {
            // Not found, perhaps deleted, get from API source
            variation = this.state.variations.find((item) => item.id == variationId)
        }
        return variation
    }
    showVariationsTag(order) {
        let variation_ary = (order.variation_ids || []).map(variationId => this.getVariation(variationId))
        const selections = order.variation_data && order.variation_data.selections || []
        let li = variation_ary.map((variation) => {

            if (!variation) {
                return null
            }
            let value = Math.abs((variation.price * 1)).toFixed(2)
            value = order.quantity * value

            let quantity = 1
            let isHasQuantity = false
            let variationDetail = selections.find(vd => vd.variation_id == variation.id)
            if (variationDetail) {
                isHasQuantity = true
                quantity = parseInt(variationDetail.quantity) || 1
            }

            return (
                <div key={"variation-" + variation.id}>
                    <span><span style={{fontSize: "120%"}}>* </span> {isHasQuantity ? `${quantity}x `: ""}{variation.name}</span>
                </div>
            )
        })
        return li
    }
    render() {
        const { order } = this.props
        return (
            <>
                {this.showVariationsTag(order)}
            </>
        )
    }
}
